import React from 'react';

import './index.css';

export default function Insights() {


	return <div>
		{'welcom to insights'}
	</div>;
}